function copyCode(element) {
  if (element.classList.contains('used')) return;

  const codeValueElement = element.querySelector('.value[data-code]');
  const code = codeValueElement ? codeValueElement.getAttribute('data-code') : null;

  if (!code) return;

  navigator.clipboard.writeText(code).then(() => {
    document.cookie = `discount_code=${code}; path=/`;

    let message = element.querySelector('.copy-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'copy-message';
      message.textContent = 'コピーしました！';
      element.appendChild(message);
    }

    element.classList.add('copied');
    setTimeout(() => {
      element.classList.remove('copied');
    }, 1000);

  }).catch(err => {
    console.error('Copy failed', err);
  });
}